import ACTIVATION_ERRORS_DATA from '../../consts/analytics/activationErrorsData';
import * as activationStatusTypes from '../../consts/gam/activationStatusTypes';
import * as yapActionStatusTypes from '../../consts/yap/yapActionStatusTypes';
import * as yapRunCommandActionTypes from '../../consts/yap/yapRunCommandActionTypes';
import * as yapWebSocketActionTypes from '../../consts/yap/yapWebSocketActionTypes';
import * as yapWebSocketEventTypes from '../../consts/yap/yapWebSocketEventTypes';
import {
    setYapActivationInProgress,
    setYapRequestActionTypeData,
    setYapUpdateSettingsInProgress,
} from '../../state/ducks/yapEncrypted';
import {makeSelectIsHolderByAssetId} from '../../state/selectors/yapEncrypted';
import {dispatch, getState} from '../../state/store';
import arrayUtils from '../../utils/arrayUtils';
import converter from '../../utils/converter';
import analyticsService from '../analyticsService';
import appErrorService from '../app/appErrorService';
import {getErrorMapping} from '../mapping/yapMappings';
import yapConnectionService from '../yap/yapConnectionService';
import yapFWUService from '../yap/yapFWUService';
import yapService from '../yap/yapService';
import yapStateService from '../yap/yapStateService';

const proceedMessage = async (message) => {
    const data = converter.stringToJson(message.data) || {};
    const {eventType, request, error, assetId, status, requestId, isSBLMode, events} = data || {};

    const gamError = getErrorMapping(error);

    switch (eventType) {
        case yapWebSocketEventTypes.CONNECTION_STATUS_CHANGE:
            yapConnectionService.proceedConnectionChange(status, assetId, isSBLMode);
            break;
        case yapWebSocketEventTypes.ASYNC_REQUEST:
            const {action, value} = request || {};
            const actionStatus = yapService.proceedAction({
                status,
                requestId,
                assetId,
                isSync: action === yapWebSocketActionTypes.REFRESH_INFO,
                isDataCollection: yapWebSocketActionTypes.isDataCollection(action),
            });

            if (!actionStatus && action !== yapWebSocketActionTypes.PROGRESS) return;

            switch (action) {
                case yapWebSocketActionTypes.ACTIVATE:
                    await proceedGamActivationAction(actionStatus, true);
                    break;
                case yapWebSocketActionTypes.DEACTIVATE:
                    await proceedGamActivationAction(actionStatus, false);
                    break;
                case yapWebSocketActionTypes.UPDATE_SETTING:
                    updateDeviceSettings(actionStatus, assetId);
                    break;
                case yapWebSocketActionTypes.REFRESH_INFO:
                    await yapConnectionService.proceedRefreshInfo(actionStatus, assetId);
                    break;
                case yapWebSocketActionTypes.PROGRESS:
                    yapFWUService.updateFirmwareProgress(assetId, value);
                    break;
                case yapWebSocketActionTypes.FIRMWARE_UPGRADE:
                    await yapFWUService.proceedFWU(actionStatus, assetId, gamError);
                    break;
                case yapWebSocketActionTypes.RESET_DEVICE:
                    await proceedResetDevice(actionStatus, assetId);
                    break;
                default:
                    break;
            }
            break;
        case yapWebSocketEventTypes.DEVICE_EVENT:
            if (!events) return;

            arrayUtils.toArray(events).forEach((event) => {
                yapStateService.updateDeviceCharacteristics(event);
            });
            break;
        default:
            break;
    }
};

const proceedResetDevice = (status, assetId) => {
    const state = getState();
    const isHolder = makeSelectIsHolderByAssetId(assetId)(state);

    dispatch(
        setYapRequestActionTypeData({
            isHolder,
            actionType: yapRunCommandActionTypes.RESET_DEVICE,
            newValue: {status},
        })
    );

    dispatch(setYapUpdateSettingsInProgress(false, isHolder));
};

const proceedGamActivationAction = async (status, isActivateAction) => {
    if (status === yapActionStatusTypes.SUCCESS) {
        const yapActivationStatus = isActivateAction
            ? activationStatusTypes.GAM_ACTIVATED
            : activationStatusTypes.GAM_DEACTIVATED;

        await yapStateService.updateActivationStatus(yapActivationStatus);
    } else {
        analyticsService.pushActivationFailedError(ACTIVATION_ERRORS_DATA.ERROR_ACTIVATION_FAILED);
    }
    dispatch(setYapActivationInProgress(false));
};

const updateDeviceSettings = (status, assetId) => {
    const isHolder = makeSelectIsHolderByAssetId(assetId)(getState());

    if (status === yapActionStatusTypes.FAILED) {
        appErrorService.showDeviceSettingsGlobalError();
    } else {
        yapStateService.updateDeviceSettings({isHolder, isNeedInformUser: true});
    }

    dispatch(setYapUpdateSettingsInProgress(false, isHolder));
};

export default {
    proceedResetDevice,
    proceedMessage,
    proceedGamActivationAction,
    updateDeviceSettings,
};
